import React from 'react';
import Lottie from "lottie-react";
import * as animationData from '../json/RW_Banner_Animation.json';

const LottieAnimation = () => {

    return (
        <>
            {animationData &&
                <Lottie animationData={animationData} loop={true} />
            }
        </>
    )
}

export default LottieAnimation;